import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './FormRow.module.scss'

export const FormRow:React.ComponentType<BaseComponentProps> = (props: BaseComponentProps) => {
  const className = extractClassNamesFromProps(props, st.row)
  return (<div className={className}>{props.children}</div>)
}

// Add displayName to preserve the component name on snapshot testing
FormRow.displayName = 'FormRow'
